import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteAllCategories } from "../../api/apiCategories";
import parseError from "../../utils/parseError";

export const useDeleteAllCategories = () => {
    const queryClient = useQueryClient();

    const {
        mutate: deleteAllCategoriesMutate,
        isPending: isDeleteAll,
    } = useMutation({
        mutationFn: deleteAllCategories,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["categories"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete categories");
        },
    });

    return {
        deleteAllCategoriesMutate,
        isDeleteAll,
    };
};
